import "./styles.css";
import { Avatar, Typography, Spin } from "antd";
import { connect } from "react-redux";
import { IMG_URL } from "../../env.json";
import { Button } from "components/Button";
import PageHeader from "components/pageHeader";
import React, { useState, useEffect } from "react";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { RightOutlined } from "@ant-design/icons";
import StdRegistrationRequest from "./modals/stdRegistrationRequest";
import {
  downloadTemplate,
  fetchCourses,
  fetchStandards,
  getAllDeviceApprovalRequests,
  getDashboard,
  setQuickAccessItem,
  setRole,
  setSelectedCourse,
  setSelectedStandard,
  setStudentWithoutData,
  setUserids,
  updateDeviceApprovalRequest,
  updateRegistrationSettings,
  updateUserRegistrations,
} from "actions/userManagementV2";
import { setCardId} from "actions/attendanceNew";
import PageDataLoader from "components/pageDataLoader";
import UserTable from "./userTable";
import AddUser from "./modals/addUser";
import ImportUser from "./modals/importUser";
import moment from "moment";
import { storeResourceData } from "actions/feeManagement";
import ConfirmRejectModal from "pages/attendanceNew/Modals/confirmRejectModal";
import ConfirmApproveModal from "pages/attendanceNew/Modals/confirmApproveModal";

const studentsIcon =
  require("../../Assets/userManagementV2/ic-students.svg").default;
const teachersIcon =
  require("../../Assets/userManagementV2/ic-teachers.svg").default;
const dataOpsIcon =
  require("../../Assets/userManagementV2/ic-dataops.svg").default;
const opsIcon = require("../../Assets/userManagementV2/ic-ops.svg").default;
const noStudents =
  require("../../Assets/userManagementV2/no-students.svg").default;
const excelFileIcon =
  require("../../Assets/userManagementV2/excelFileIcon.svg").default;
const infoCircleIcon =
  require("../../Assets/userManagementV2/infoCircleIcon.svg").default;
const analyticsIcon =
  require("../../Assets/userManagementV2/analyticsIcon.svg").default;
const deleteBinIcon =
  require("../../Assets/userManagementV2/deleteBinIcon.svg").default;
const NoData = require("../../Assets/ill-no-data.svg").default;

const SUSPENDED_USER_MESSAGE =
  "User account is suspended. Restore the account before processing this request.";

const NoDataCard = ({ filter = "pending" }) => {
  return (
    <div
      className="r-c-c-c"
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
    }}>
      <img src={NoData} />
      <div
        style={{
          color: "#191919",
          fontWeight: "700",
          fontStyle: "roboto",
          fontSize: "16px",
        }}
      >
        No {filter.charAt(0).toUpperCase() + filter.slice(1)} Requests
      </div>
      <div
        style={{
          color: "#636363",
          fontWeight: "600",
          fontStyle: "roboto",
          fontSize: "11px",
        }}
      >
        There are currently no {filter} device change requests. Please check
        back later
      </div>
    </div>
  );
};

const roleDetails = (
  data,
  history,
  setRole,
  setStudentWithoutData,
  setSelectedCourse,
) => {
  if (data) {
    return [
      {
        label: "Students",
        count: data[0]?.totalCount,
        icon: studentsIcon,
        onClick: () => {
          setSelectedCourse("");
          setStudentWithoutData(undefined);
          history.push("/user-management/courses");
          setRole("userRole", "Students");
        },
        lastWeekCount: data[0]?.createdLastWeekCount,
      },
      {
        label: "Teachers",
        count: data[1]?.totalCount,
        icon: teachersIcon,
        onClick: () => {
          setSelectedCourse("");
          setStudentWithoutData(undefined);
          history.push("/user/staff");
          setRole("userRole", "Teachers");
        },
        lastWeekCount: data[1]?.createdLastWeekCount,
      },
      {
        label: "Data Operators",
        count: data[2]?.totalCount,
        icon: dataOpsIcon,
        onClick: () => {
          setSelectedCourse("");
          setStudentWithoutData(undefined);
          history.push("/user/staff");
          setRole("userRole", "Data Operators");
        },
        lastWeekCount: data[2]?.createdLastWeekCount,
      },
      {
        label: "Operations",
        count: data[3]?.totalCount,
        icon: opsIcon,
        onClick: () => {
          setSelectedCourse("");
          setStudentWithoutData(undefined);
          history.push("/user/staff");
          setRole("userRole", "Operations");
        },
        lastWeekCount: data[3]?.createdLastWeekCount,
      },
    ];
  } else {
    return [
      { label: "Students", count: "loading...", icon: studentsIcon },
      { label: "Teacher", count: "loading...", icon: teachersIcon },
      { label: "Data Operators", count: "loading...", icon: dataOpsIcon },
      { label: "Operations", count: "loading...", icon: opsIcon },
    ];
  }
};

const RoleCard = ({ data, index }) => {
  return (
    <div
      key={index}
      onClick={data?.onClick}
      className="CardShadow cursor-pointer"
      style={{
        border: "1px solid #E6E6E6",
        height: "14vh",
        width: "17vw",
        borderRadius: 8,
        marginTop: 5,
        minWidth: "250px",
      }}
    >
      <div className="p-20">
        <div className="r-jsb" style={{ width: "100%" }}>
          <div style={{}} className="simGrey text-md bold-600">
            {data?.count}
          </div>
          <div>
            {" "}
            <img src={data?.icon} style={{ width: 45 }} />
          </div>
        </div>
        <div style={{ fontSize: 12, marginTop: -6, color: "#AEAEAE" }}>
          {data?.label === "Students" ? (
            <span style={{ color: "#636363", fontWeight: 700 }}>Students</span>
          ) : (
            <>
              {data?.label == "Teachers" ||
              data?.label == "Data Operators" ||
              data?.label == "Operations"
                ? "Staff"
                : "Students"}{" "}
              in{" "}
              <span style={{ color: "#636363", fontWeight: 700 }}>
                {data?.label}
              </span>
            </>
          )}
        </div>
        <div style={{ fontSize: 10, color: "#28DF99", fontWeight: 600 }}>
          {data?.lastWeekCount != 0 ? (
            <>
              {data?.lastWeekCount > 0 ? (
                <div
                  style={{ fontSize: 10, color: "#28DF99", fontWeight: 600 }}
                >
                  +{data?.lastWeekCount} from last week
                </div>
              ) : (
                <div style={{ fontSize: 10, color: "#FF414D" }}>
                  {data?.lastWeekCount} from last week
                </div>
              )}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const AddUsers = ({
  setAdduserModal,
  setImportModal,
  handleDownloadTemplate,
  downloadLoader,
}) => {
  return (
    <div
      className="addUsersCard CardShadow"
      style={{
        width: "98%",
        height: "100%",
        backgroundColor: "#F6F4FE",
        border: "1px solid #E6E6E6",
        borderRadius: 8,
        padding: 10,
        display: "flex",
      }}
    >
      <img src={noStudents} style={{ width: "25%", height: "100%" }} />
      <div className="flex-column" style={{ marginLeft: 30, marginTop: 10 }}>
        <div style={{ color: "#191919", fontSize: 16, fontWeight: 700 }}>
          Add users
        </div>
        <div style={{ color: "#636363", fontSize: 14, fontWeight: 500 }}>
          Add users by importing in groups or by filling a form manually
        </div>
        <div
          onClick={(e) => handleDownloadTemplate(e)}
          className="display-flex cursor-pointer"
          style={{ display: "flex", alignItems: "center" }}
        >
          <img src={excelFileIcon} style={{ width: 15, marginRight: 10 }} />
          <Button
            loading={downloadLoader}
            type="transparent"
            style={{ color: "#1089FF", padding: 0 }}
          >
            DOWNLOAD EXCEL TEMPLATE{" "}
            {!downloadLoader ? (
              <span
                style={{
                  backgroundColor: "#FF414D",
                  color: "#FFF",
                  marginLeft: 5,
                  fontSize: 10,
                  width: 40,
                  borderRadius: 2,
                  padding: 3,
                }}
              >
                NEW
              </span>
            ) : null}
          </Button>
        </div>
        <div className="display-flex">
          <img src={infoCircleIcon} style={{ width: 15, marginRight: 10 }} />
          <div style={{ color: "#FF414D" }}>
            Please download the new Excel Template
          </div>
        </div>
        <div className="display-flex m-t-10">
          <Button
            type="primary"
            onClick={() => {
              setAdduserModal(true);
            }}
          >
            FILL FORM
          </Button>
          <Button
            type="transparent"
            onClick={() => setImportModal(true)}
            style={{ color: "#594099" }}
          >
            IMPORT
          </Button>
        </div>
      </div>
    </div>
  );
};

const AnalyticsAndDeleteUserCards = ({
  icon,
  title,
  subTitle,
  actionButton,
  onClick,
}) => {
  return (
    <div
      className="CardShadow"
      style={{
        border: "1px solid #E6E6E6",
        height: "100%",
        width: "96%",
        backgroundColor: "white",
        borderRadius: 8,
        padding: 13,
      }}
    >
      <div className="flex-column">
        <img src={icon} style={{ width: 50 }} />
        <div
          className="m-t-5"
          style={{ color: "#191919", fontWeight: 700, fontSize: 16 }}
        >
          {title}
        </div>
        <div
          className="m-t-5"
          style={{ color: "#636363", fontWeight: 500, fontSize: 14 }}
        >
          {subTitle}
        </div>
        <Button
          type="transparent"
          style={{
            color: "#1089FF",
            fontSize: 16,
            padding: 0,
            cursor: title == "Analytics" ? "Not-allowed" : "pointer",
          }}
          onClick={onClick}
        >
          {actionButton}
        </Button>
      </div>
    </div>
  );
};

const RegistrationRequestCard = ({
  image,
  userName,
  phone,
  course,
  approvalType,
  updateUserRegistrations,
  updateDeviceApprovalRequest,
  getAllDeviceApprovalRequests,
  previousDevice,
  requestedDevice,
  id,
  togglePageLoader,
  toggleCardLoader,
  params,
  getDashboard,
  timeDiff,
  user,
  setCardId,
  currentFilter,
  // setActionData,
  // requestedActionData,
}) => {
  const [approveLoader, setApproveLoader] = useState(false);
  const [rejectLoader, setRejectLoader] = useState(false);
  const [isRejectModalVisible, setIsRejectModalVisible] = useState(false);
  const [isApproveModalVisible, setIsApproveModalVisible] = useState(false);

  const timeSinceNow = moment.utc(timeDiff).local().fromNow();

  const successCallback = () => {
    togglePageLoader(true);
    getDashboard(params, () => togglePageLoader(false));
  };

  const handleButtonActions = (status, id) => {
    const setLoadingState = (loaderState) => {
      if (status === "Approved") {
        setApproveLoader(loaderState);
      } else {
        setRejectLoader(loaderState);
      }
    };

    setLoadingState(true);
    if (updateDeviceApprovalRequest) {
      const params = {
        requestId: id,
        approvalStatus: status === "Approved" ? "approved" : "rejected",
        approvedBy: user.id,
      };
      updateDeviceApprovalRequest(params, (errorMessage) => {
        setLoadingState(false);
        if (errorMessage === SUSPENDED_USER_MESSAGE) {
          return;
        }
        toggleCardLoader(true);
        getAllDeviceApprovalRequests({ status: currentFilter || "pending" }, () =>
          toggleCardLoader(false),
        );
      });
    } else {
      const registrationsParams = {
        requestStatuses: [
          {
            userId: id,
            status: status,
          },
        ],
      };
      updateUserRegistrations(
        registrationsParams,
        () => setLoadingState(false),
        () => successCallback(),
      );
    }
  };

  return (
    <div className="r-c-c" style={{}}>
      <div className="r-ac flex-2">
        <Avatar
          src={image}
          style={{ borderRadius: "50%", marginTop: 10, width: 50, height: 50 }}
        ></Avatar>
        <div className="p-10 m-t-10" style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
            <Typography.Text
              ellipsis={{ tooltip: true }}
              style={{ color: "#191919", fontWeight: 600, fontSize: 14, minWidth: 0 }}
            >
              {userName}
            </Typography.Text>
            {timeDiff && (
              <Typography.Text style={{ color: "#636363", fontSize: 12, whiteSpace: "nowrap", flexShrink: 0 }}>
                {`• ${timeSinceNow}`}
              </Typography.Text>
            )}
          </div>
          {phone && (
            <div>
              <Typography.Text style={{ color: "#454545", fontWeight: 600, fontSize: 12, whiteSpace: "nowrap" }}>
                Mobile number -{" "}
              </Typography.Text>
              <Typography.Text style={{ color: "#454545", fontSize: 12, whiteSpace: "nowrap" }}>
                {phone?.replace(/^\+91/, "")}
              </Typography.Text>
            </div>
          )}
          <div>
            <div style={{ display: "flex", gap: "1rem" }}>
              <Typography.Text style={{ color: "#454545", fontSize: 12, whiteSpace: "nowrap" }}>
                <span style={{ fontWeight: 600 }}>Old device - </span>
                {previousDevice}
              </Typography.Text>
              <Typography.Text style={{ color: "#454545", fontSize: 12, whiteSpace: "nowrap" }}>
                <span style={{ fontWeight: 600 }}>New device - </span>
                {requestedDevice}
              </Typography.Text>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1" style={{ width: "100%" }}>
        {approvalType === "Auto Approval" ? (
          <div style={{ color: "#636363", padding: 0 }}>{timeSinceNow}</div>
        ) : user?.privilage?.includes("SuperAdmin") ||
          user?.privilage?.includes("Admin") ? (
          <div
            className={currentFilter === "pending" ? "" : "r-jsb"}
            style={
              currentFilter === "pending"
                ? { width: "100%", display: "flex", justifyContent: "flex-end", gap: 32 }
                : { width: "100%" }
            }
          >
            {currentFilter !== "rejected" && (
              <>
                <Button
                  loading={rejectLoader}
                  type="transparent"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCardId(id);
                    setIsRejectModalVisible(true);
                  }}
                  style={{ padding: 0, color: "#FF414D", marginLeft: currentFilter === "approved" ? "auto" : 0 }}
                >
                  {currentFilter === "approved" ? "CHANGE TO REJECT" : "REJECT"}
                </Button>
                <ConfirmRejectModal
                  isRejectModalVisible={isRejectModalVisible}
                  setIsRejectModalVisible={setIsRejectModalVisible}
                  setCardId={setCardId}
                  id={id}
                  functionProp={() => handleButtonActions("Rejected", id)}
                  skipRequestAction
                  togglePageLoader={togglePageLoader}
                />
              </>
            )}
            {currentFilter !== "approved" && (
              <>
                <Button
                  loading={approveLoader}
                  type="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCardId(id);
                    setIsApproveModalVisible(true);
                  }}
                  style={{
                    backgroundColor: "#28DF99",
                    border: "none",
                    color: "white",
                    marginLeft: currentFilter === "rejected" ? "auto" : 0,
                  }}
                >
                  {currentFilter === "rejected" ? "CHANGE TO APPROVE" : "APPROVE"}
                </Button>
                <ConfirmApproveModal
                  isApproveModalVisible={isApproveModalVisible}
                  setIsApproveModalVisible={setIsApproveModalVisible}
                  setCardId={setCardId}
                  id={id}
                  functionProp={() => handleButtonActions("Approved", id)}
                  skipRequestAction
                  togglePageLoader={togglePageLoader}
                />
              </>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const FILTER_CHIPS = [
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
];

const UserRegistrationWrapper = ({
  heading,
  approvalType,
  changeSetting,
  data,
  setChangeSetting,
  handleVAClick,
  updateUserRegistrations,
  updateDeviceApprovalRequest,
  getAllDeviceApprovalRequests,
  getDashboard,
  params,
  togglePageLoader,
  user,
  setCardId,
  deviceFilter,
  setDeviceFilter,
  // setActionData,
  // requestedActionData,
}) => {
  const [cardLoading, setCardLoading] = useState(false);

  const handleFilterChange = (value) => {
    if (value === deviceFilter) return;
    setDeviceFilter(value);
    setCardLoading(true);
    getAllDeviceApprovalRequests({ status: value }, () => setCardLoading(false));
  };

  return (
    <div
      className="CardShadow show-scroll-on-hover"
      style={{
        border: "1px solid #E6E6E6",
        borderRadius: 8,
        height: "100%",
        width: "98%",
        padding: 15,
        overflow: "hidden",
        backgroundColor: "#FFF",
        display: "flex",
        flexDirection: "column",
        position: "relative",
      }}
    >
      <div className="r-jsb r-ac" style={{ marginBottom: 10 }}>
        <div style={{ color: "#191919", fontWeight: 700, fontSize: 16 }}>
          {heading}
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {FILTER_CHIPS.map((chip) => {
            const isSelected = deviceFilter === chip.value;
            return (
              <div
                key={chip.value}
                onClick={() => handleFilterChange(chip.value)}
                style={{
                  padding: "4px 12px",
                  borderRadius: 20,
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                  border: `1px solid ${isSelected ? "#594099" : "#D9D9D9"}`,
                  backgroundColor: isSelected ? "#594099" : "#FFF",
                  color: isSelected ? "#FFF" : "#636363",
                  transition: "all 0.2s",
                }}
              >
                {chip.label}
              </div>
            );
          })}
        </div>
      </div>
      <div className="hide-scrollbar" style={{ flex: 1, overflowY: "auto", position: "relative" }}>
        {cardLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFF",
              zIndex: 10,
            }}
          >
            <Spin size="large" />
          </div>
        )}
        {data?.length === 0 ? (
          <NoDataCard filter={deviceFilter} />
        ) : (
          data?.map((item) => (
            <div style={{ padding: 0 }} key={item?.id}>
              <RegistrationRequestCard
                timeDiff={
                  deviceFilter === "approved" || deviceFilter === "rejected"
                    ? item?.updatedAt
                    : item?.createdAt
                }
                togglePageLoader={togglePageLoader}
                toggleCardLoader={setCardLoading}
                params={params}
                getDashboard={getDashboard}
                id={item?.id}
                image={`${IMG_URL}/${item?.user?.image}`}
                userName={item?.user?.name}
                phone={item?.user?.phone}
                course={item?.role}
                updateDeviceApprovalRequest={updateDeviceApprovalRequest}
                getAllDeviceApprovalRequests={getAllDeviceApprovalRequests}
                user={user}
                setCardId={setCardId}
                currentFilter={deviceFilter}
                // setActionData={setActionData}
                // requestedActionData={requestedActionData}
                previousDevice={
                  item.currentDeviceMake + " " + item.currentDeviceModel
                }
                requestedDevice={
                  item.requestedDeviceMake + " " + item.requestedDeviceModel
                }
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const UsersDashboard = ({
  getDashboard,
  dashboardMeta,
  updateRegistrationSettings,
  setRole,
  downloadTemplate,
  updateUserRegistrations,
  user,
  fetchStandards,
  fetchCourses,
  setSelectedCourse,
  setStudentWithoutData,
  setUserids,
  setSelectedStandard,
  setQuickAccessItem,
  quickAccessItem,
  getAllDeviceApprovalRequests,
  deviceApprovalRequests,
  updateDeviceApprovalRequest,
  setCardId,
  // setActionData,
  // requestedActionData,
}) => {
  const bodyStyle = {
    background: "#FAFAFA",
    width: "calc(100% + 30px)",
    height: "calc(100% + 40px)",
    margin: -20,
    padding: 20,
    marginTop: 20,
    paddingBottom: 20,
    display: "flex",
    flexDirection: "column",
  };

  const location = useLocation();

  useEffect(() => {
    //fetches standards & course array for filters...
    fetchStandards();
    fetchCourses();
    setUserids([]);

    if (quickAccessItem == "addUser") {
      setAdduserModal(true);
    }
  }, []);

  const history = useHistory();
  // const [changeSettingOpen, setChangeSetting] = useState(false);
  const [dashboardDetails, setDashboardDetails] = useState({});
  const [pageLoader, togglePageLoader] = useState(false);
  const [addUserModal, setAdduserModal] = useState(false);
  const [importUsers, setImportModal] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [deviceFilter, setDeviceFilter] = useState("pending");

  let params = {
    userType: "Student",
    status: "Approved",
    limit: 10,
  };

  useEffect(() => {
    setDashboardDetails({ ...dashboardMeta });
  }, [dashboardMeta]);

  useEffect(() => {
    togglePageLoader(true);
    getDashboard(params, () => togglePageLoader(false));
  }, []);

  // const onCloseSettingModal = () => {
  //         setChangeSetting(false);
  // };

  useEffect(() => {
    const param = { status: "pending" };
    togglePageLoader(true);
    getAllDeviceApprovalRequests(param, () => togglePageLoader(false));
  }, []);

  const handleDownloadTemplate = (e) => {
    e.stopPropagation();
    setDownloadLoader(true);
    downloadTemplate(() => setDownloadLoader(false));
  };

  return (
    <div style={bodyStyle}>
      <div>
        <PageHeader title="User management" actions={null} />
      </div>
      {pageLoader ? (
        <></>
      ) : (
        <>
          <div
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {roleDetails(
              dashboardDetails?.roleWiseCountStats,
              history,
              setRole,
              setStudentWithoutData,
              setSelectedCourse,
            )?.map((item, index) => (
              <div style={{ flex: 1 }} key={index}>
                <RoleCard data={item} index={index} />
              </div>
            ))}
          </div>
          {(user?.privilage?.includes("FeeManager") ||
            user?.privilage?.includes("LeaveManager")) &&
          !user?.privilage?.includes("Admin") ? null : (
            <div className="r-jsb m-t-30" style={{ flexShrink: 0 }}>
              <div style={{ flex: 1 }}>
                <AddUsers
                  setAdduserModal={setAdduserModal}
                  setImportModal={setImportModal}
                  handleDownloadTemplate={handleDownloadTemplate}
                  downloadLoader={downloadLoader}
                />
              </div>
              {/* <div style={{ flex: 1 }}>
                                                                        <AnalyticsAndDeleteUserCards icon={analyticsIcon} title={'Analytics'} subTitle={'Analyze and understand user groups and get instant visualization.'} actionButton={'VIEW'} />
                                                                </div> */}
              <div style={{ flex: 1 }}>
                <AnalyticsAndDeleteUserCards
                  icon={deleteBinIcon}
                  title={"Suspended Users"}
                  subTitle={
                    "You can restore a deleted user, or permanently delete a user."
                  }
                  actionButton={"VIEW"}
                  onClick={() => history.push("/user-management/deleted-users")}
                />
              </div>
            </div>
          )}
          <div className="r-jsb" style={{ flex: 1, marginTop: 30, minHeight: 0 }}>
            {["SuperAdmin", "Admin"].some((privilage) =>
              user?.privilage?.includes(privilage),
            ) && (
              <div style={{ height: "100%", flex: 1 }}>
                <UserRegistrationWrapper
                  togglePageLoader={togglePageLoader}
                  params={params}
                  getDashboard={getDashboard}
                  updateUserRegistrations={updateUserRegistrations}
                  updateDeviceApprovalRequest={updateDeviceApprovalRequest}
                  getAllDeviceApprovalRequests={getAllDeviceApprovalRequests}
                  handleVAClick={() => {
                    setRole("userRole", "Students");
                    setUserids([]);
                    setStudentWithoutData(undefined);
                    setSelectedStandard("");
                    setSelectedCourse("All Requests");
                    history.push("/user/student");
                  }}
                  data={deviceApprovalRequests}
                  heading="Student Device Change Approval Requests"
                  user={user}
                  setCardId={setCardId}
                  deviceFilter={deviceFilter}
                  setDeviceFilter={setDeviceFilter}
                  // setActionData={setActionData}
                  // requestedActionData={requestedActionData}
                />
              </div>
            )}
            {/* <div style={{ height: '100%', flex: 1 }}>
                                                                <UserRegistrationWrapper togglePageLoader={togglePageLoader} params={params} getDashboard={getDashboard} updateUserRegistrations={updateUserRegistrations} handleVAClick={() => { history.push('/user/registration/requests'); setRole('userRole', 'staff') }} data={dashboardDetails?.staffRegistrationRequests?.items} heading='Staff Registration Requests' approvalType={'Manual Approval'} user={user} />
                                                        </div> */}
          </div>
        </>
      )}
      {/* {changeSettingOpen && <StdRegistrationRequest open={changeSettingOpen} onClose={onCloseSettingModal} updateRegistrationSettings={updateRegistrationSettings} getDashboard={getDashboard} params={params} togglePageLoader={togglePageLoader} dashboardDetails={dashboardDetails} />} */}
      {addUserModal && (
        <AddUser
          open={addUserModal}
          onCancel={() => {
            setAdduserModal(false);
            setQuickAccessItem({ addUser: false });
          }}
          params={params}
          getDashboard={getDashboard}
        />
      )}
      {importUsers && (
        <ImportUser open={importUsers} onCancel={() => setImportModal(false)} />
      )}
      <PageDataLoader visible={pageLoader} />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.session;
  const { dashboardMeta, quickAccessItem, deviceApprovalRequests } =
    state.userManagementV2;
  return { dashboardMeta, user, quickAccessItem, deviceApprovalRequests };
};

const mapDispatchToProps = (dispatch) => ({
  getDashboard: (params, callback) => dispatch(getDashboard(params, callback)),
  updateRegistrationSettings: (params, callback) =>
    dispatch(updateRegistrationSettings(params, callback)),
  setRole: (key, val) => dispatch(setRole(key, val)),
  downloadTemplate: (callback) => dispatch(downloadTemplate(callback)),
  updateUserRegistrations: (params, callback, successCallback) =>
    dispatch(updateUserRegistrations(params, callback, successCallback)),
  fetchStandards: (params) => dispatch(fetchStandards(params)),
  fetchCourses: (params) => dispatch(fetchCourses(params)),
  setSelectedCourse: (res) => dispatch(setSelectedCourse(res)),
  setStudentWithoutData: (res) => dispatch(setStudentWithoutData(res)),
  setUserids: (userIds) => dispatch(setUserids(userIds)),
  setSelectedStandard: (res) => dispatch(setSelectedStandard(res)),
  setQuickAccessItem: (res) => dispatch(setQuickAccessItem(res)),
  getAllDeviceApprovalRequests: (params, callback) =>
    dispatch(getAllDeviceApprovalRequests(params, callback)),
  updateDeviceApprovalRequest: (params, callback) =>
    dispatch(updateDeviceApprovalRequest(params, callback)),
  setCardId: (id) => dispatch(setCardId(id)),
  // setActionData: (val) => dispatch(setActionData(val)),
  // requestedActionData: (callback, successCallback) =>
  //   dispatch(requestedActionData(callback, successCallback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersDashboard);
